export const getAuthRoute = (route: string, path: string) => {
  const nextParam = window.location.search.match(/next=([^&]+)/)?.[1];

  const formattedRoutePath = `${route}${path}`;
  const formattedRoute = formattedRoutePath.endsWith('/') ? formattedRoutePath : `${formattedRoutePath}/`;

  if (nextParam) {
    return `${formattedRoute}?next=${nextParam}`;
  }
  return formattedRoute;
};
